'use strict';

const rp_app = globalThis.rp_app || {};
const datadogLogsModule = require('@datadog/browser-logs');

const datadogLogs = datadogLogsModule.datadogLogs || datadogLogsModule;

initializeDatadogLogs();

rp_app.datadogLogs = datadogLogs;
rp_app.logger = createLogger();

rp_app.track = require('public/js/lib/track');
rp_app.notify = require('public/js/lib/notify').notify;
rp_app.query = require('public/js/lib/query');
rp_app.cacheConfig = require('public/js/lib/cache-config');
// Allow for plugin to override the global object
rp_app.location = globalThis.$location || require('public/js/lib/location')(globalThis);

module.exports = rp_app;

// Helper functions

// Initialize Datadog Logs if configuration is available
function initializeDatadogLogs() {
	if (!globalThis.__DD_CONFIG__ || !globalThis.__DD_CONFIG__.clientToken) {
		return;
	}

	if (!datadogLogs || typeof datadogLogs.init !== 'function') {
		return;
	}

	try {
		datadogLogs.init({
			clientToken: globalThis.__DD_CONFIG__.clientToken,
			site: 'datadoghq.com',
			forwardErrorsToLogs: true,			
			sessionSampleRate: 100,
			service: globalThis.__DD_CONFIG__.service,
			env: globalThis.__DD_CONFIG__.env,
			version: globalThis.__DD_CONFIG__.version,
			beforeSend: createBeforeSendHook(),
		});
	} catch (e) {
		// Errors during initialization shouldn't break the application so we fail silently
		void e;
	}
}

function createBeforeSendHook() {
	let webstoreMetadata = null;

	const getWebstoreMetadata = () => {
		if (webstoreMetadata !== null) {
			return webstoreMetadata;
		}

		try {
			const body = document.body;
			webstoreMetadata = {
				store_hash: body?.dataset?.storeHash ?? null,
			};
		} catch (e) {
			webstoreMetadata = { store_hash: null };
		}

		return webstoreMetadata;
	};

	return (log) => {
		try {
			// Filter out generic cross-origin errors (not actionable)
			if (log.message === 'Script error.' || log.error?.message === 'Script error.') {
				return false;
			}
			
			const webstoreMeta = getWebstoreMetadata();
			Object.assign(log, webstoreMeta);
			return true;
		} catch (e) {
			// If beforeSend fails, allow the log through without metadata
			return true;
		}
	};
}

// Create logger wrapper that uses datadogLogs.logger directly
// Maintains API compatibility with the old Logger class
function createLogger() {
	if (!datadogLogs || !datadogLogs.logger) {
		// Return no-op logger if Datadog isn't initialized
		return {
			info: () => {},
			error: () => {},
		};
	}

	return {
		info: (data = {}) => {
			try {
				if (!data || !data.message) {
					return;
				}
				datadogLogs.logger.info(data.message, data);
			} catch (e) {
				// Silently fail - don't break the app if logging fails
				void e;
			}
		},
		error: (data = {}) => {
			try {
				if (!data || !data.message) {
					return;
				}
				datadogLogs.logger.error(data.message, data);
			} catch (e) {
				// Silently fail - don't break the app if logging fails
				void e;
			}
		},
	};
}
